import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ApiKeysActionTypes } from './apiKeys.types';
import {
  generateApiKeySuccess,
  generateApiKeyFailure,
  getApiKeyRequest,
  getApiKeySuccess,
  getApiKeyFailure,
} from './apiKeys.action';
import {
  generateApiKey,
  getApiKey,
} from '../../services/apiKeyService/apiKeyService';

// Generate API Key Saga
function* generateApiKeySaga(): SagaIterator {
  try {
    const apiKey = yield call(generateApiKey);
    yield put(generateApiKeySuccess(apiKey));
    // After successful generation, fetch the latest API key
    yield put(getApiKeyRequest());
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to generate API key';
    yield put(generateApiKeyFailure(errorMessage));
  }
}

// Get API Key Saga
function* getApiKeySaga(): SagaIterator {
  try {
    const apiKey = yield call(getApiKey);
    yield put(getApiKeySuccess(apiKey));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch API key';
    yield put(getApiKeyFailure(errorMessage));
  }
}

// Root API Keys Saga
export function* apiKeysSaga() {
  yield takeLatest(
    ApiKeysActionTypes.GENERATE_API_KEY_REQUEST,
    generateApiKeySaga
  );
  yield takeLatest(ApiKeysActionTypes.GET_API_KEY_REQUEST, getApiKeySaga);
}
